import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  const featuredArticles = articles.slice(0, 4);

  return (
    <section className="w-full py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新资讯
            </h2>
            <p className="text-sm text-foreground-600 mt-1">赛事分析 · 竞猜攻略 · 平台动态</p>
          </div>
          <Link
            to="/category/other"
            className="hidden sm:flex items-center gap-1 text-sm text-accent-700 hover:text-accent-800 transition-colors duration-200 font-medium"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-accent-300 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-500">{article.readTime}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-accent-700 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-500">{article.date}</span>
                  <span className="text-xs text-accent-700 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    阅读全文
                    <i className="ri-arrow-right-line ml-1"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-6">
          <Link
            to="/category/other"
            className="flex items-center gap-1 text-sm text-accent-700 hover:text-accent-800 transition-colors duration-200 font-medium"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}